export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/hu.7211558e.svg","height":3,"width":6,"blurWidth":0,"blurHeight":0};